// import React from 'react';
import { toast } from "react-toastify";

import axios from "axios";

import Cookies from "js-cookie";

import "react-toastify/dist/ReactToastify.css";

import {
  TrackGoogleAnalyticsEvent,
  setUserSessionSource,
} from "./GoogleAnalytics";

export const appUrl = process.env.REACT_APP_URL;

export const laravelApiUrl = process.env.REACT_APP_LARAVEL_API_URL;

export const laravelFrontApiUrl = process.env.REACT_APP_LARAVEL_FRONT_API_URL;

export const appAbsPath = process.env.REACT_APP_ABSPATH;

export const srcUrl = process.env.REACT_APP_SRCURL;

export const appSrcUrl = process.env.REACT_APP_SRC;

export const appSecretKey = process.env.REACT_APP_SECRET_KEY;

export const s3url =
  process.env.REACT_APP_IMAGEUPLOADENV === "spaces"
    ? process.env.REACT_APP_S3URL
    : process.env.REACT_APP_URL + "/backend/public/uploads";

export const userToken = localStorage.getItem("bwToken");

// export const userSrd = localStorage.getItem('srd');

export const userSrd = Cookies.get("srd") || localStorage.getItem("srd");

// export const selectedcity = sessionStorage.getItem('city') || 'pune';

export const buttonLoadingClass = "btn__dots--loading";

export const approvedCities = process.env.REACT_APP_APPROVED_CITIES.split(",");
export const commonApis = process.env.REACT_APP_COMMON_APIS.split(",") || [];

export const add = (a, b) => a + b;

export const subtract = (a, b) => a - b;

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const BUILD_TARGET = process.env.REACT_APP_BUILD_TARGET; // "admin" | "user"
const cityCookieName =
  BUILD_TARGET === "admin" ? "selectedCityCookie" : "globalCity";


export const fetchedFromPortal = {
  rera: "Rera",
  Acre99: "Acre99",
  dwello: "Dwello",
  custom: "Custom",
};

// const TRACKING_ID = "G-B84KD79XTF"; // Live

export const clog = (data, stop = 0, msg = "") => {
  if (msg) {
    console.log(msg);
  }

  console.log(data);

  if (stop === 1) {
    return false;
  }
};

export const getCityFromCurrentUrl = (defaultCity = "pune") => {
  if (window.location.pathname.includes("pune")) {
    return "pune";
  } else if (window.location.pathname.includes("mumbai")) {
    return "mumbai";
  } else {
    return defaultCity;
  }
};

export const setCookie = (name, value) => {

  Cookies.set(name, value, {
    sameSite: "strict",
    httpOnly: true,
    secure: true,
  });
};

export const parsedUserData = Cookies.get("userData")
  ? JSON.parse(Cookies.get("userData"))
  : null;

export const getCookie = (name) => {
  return Cookies.get(name);
};

//export const userToken = getCookie('bwToken');

export const deleteCookie = (name) => {
  setCookie(name, "", { expires: -1 });
};

export const priceFormat = (price) => {
  const formattedPrice = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(price);

  return formattedPrice;
};

export const toSentenceCase = (str) => {
  if (!str) return "";

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatDateForDatepicker = (dateString) => {
  const date = new Date(dateString);

  // Extract year, month, and day parts

  const year = date.getFullYear();

  const month = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 to month (0-indexed) and pad to 2 digits

  const day = String(date.getDate()).padStart(2, "0"); // Pad day to 2 digit

  // Return in yyyy-mm-dd format

  return `${year}-${month}-${day}`;
};

export const formatDateReadable = (dateString) => {
  const passedDate = new Date(dateString);

  const formattedDate = passedDate.toLocaleDateString("en-GB", {
    day: "numeric",

    month: "short",

    year: "numeric",
  });

  return formattedDate;
};

export const cleanedPrice = (price) => {
  const cleanedValue = price.replace(/₹|,/g, "");

  return cleanedValue;
};

export const progressBar = async (setLoading, setProgress) => {
  setLoading(true);

  // Simulating a long-running functionality

  for (let i = 0; i <= 100; i++) {
    setProgress(i);

    await new Promise((resolve) => setTimeout(resolve, 1));
  }

  setLoading(false);
};

//Get Logged User Information

export const userData = async () => {
  if (userToken) {
    const loggedUserData = executeLaravelAPI("profile", "", "GET", userToken);

    return loggedUserData;
  }

  return "";
};

//Show Message once operation is done

export const showToastMessage = (
  message = "",
  position = "top-right",
  type = "info",
) => {
  // Available types: 'info', 'success', 'warning', 'error'

  toast[type](message, {
    position: position,

    autoClose: 3000,

    hideProgressBar: false,

    closeOnClick: true,

    pauseOnHover: true,

    draggable: true,
  });
};

// Laravel API Execution

function checkEndpoint(endpoint) {
  const routes = commonApis.map(route => route.split("?")[0]);
  const clean = endpoint.split("?")[0];
  return routes.some(route => 
    clean === route || clean.startsWith(route + "/")
  );
}

export const executeLaravelFrontAPI = async (
  apiEndPoint,
  data = "",
  apiMethod = "POST",
  customHeaders = {}
) => {
  try {
    const updatedJsonData = { ...data };
    const apiUrl = laravelFrontApiUrl + "/" + apiEndPoint;

    let urlWithParams = apiUrl;

    // ✅ Check if running on localhost → auto-add bwusercheck=1

    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

    if (isLocalhost) {
      updatedJsonData.bwusercheck = 1;
    }

    // ✅ Handle GET requests (build query string)

    if (apiMethod === "GET") {
      urlWithParams = new URL(apiUrl);

      Object.keys(updatedJsonData).forEach((key) =>
        urlWithParams.searchParams.append(key, updatedJsonData[key]),
      );
    }

    const endpoint = apiEndPoint.split('/').slice(-1)[0];
    const isCommonApi = commonApis.includes(endpoint);
    const requestOptions = {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        "X-CITY": isCommonApi ? "common" : (customHeaders["X-CITY"] || getCookie(cityCookieName) || 'pune'),
        "x-app-key": appSecretKey,
        ...customHeaders,
      },
    };

    // ✅ Add body for POST/PUT/etc.

    if (updatedJsonData && apiMethod !== "GET") {
      requestOptions.body = JSON.stringify(updatedJsonData);
    }

    const response = await fetch(urlWithParams, requestOptions);

    if (response.status === 200) {
      return await response.json();
    } else {
      return "";
    }
  } catch (error) {
    console.error("API Error (Front):", error.message);

    throw error;
  }
};

// Laravel API Execution

export const executeLaravelAPI = async (
  apiEndPoint,
  data = "",
  apiMethod = "POST",
  authToken = "",
  options = {},
) => {
  try {
    const apiUrl = laravelApiUrl + "/" + apiEndPoint;

    let urlWithParams = apiUrl;

    // make a shallow copy so we don't mutate caller's object

    const requestData = { ...data };

    // Add bwusercheck=1 when API URL or current host is localhost

    const isLocalhostApi =
      typeof laravelApiUrl === "string" &&
      (laravelApiUrl.includes("localhost") ||
        laravelApiUrl.includes("127.0.0.1"));

    const isLocalhostWindow =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

    if (isLocalhostApi || isLocalhostWindow) {
      requestData.bwusercheck = 1;
    }

    if (apiMethod === "GET") {
      urlWithParams = new URL(apiUrl);

      Object.keys(requestData).forEach((key) =>
        urlWithParams.searchParams.append(key, requestData[key]),
      );
    }

    //const endpoint = apiEndPoint.split('/').slice(-1)[0];
    const isCommonApi = checkEndpoint(apiEndPoint);
    const requestOptions = {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        "X-CITY": isCommonApi ? "common" : (getCookie(cityCookieName) ?? "pune"),
        "x-app-key": appSecretKey,
      },
    };

    // Check if authToken is available and add it to headers

    if (authToken) {
      delete requestOptions.headers["Content-Type"];

      requestOptions.headers["Authorization"] = `Bearer ${authToken}`;
    }

    // Check if data is available

    if (requestData && apiMethod !== "GET") {
      requestOptions.body = JSON.stringify(requestData);
    }

    const response = await fetch(
      urlWithParams,

      requestOptions,
    );

    const { raw = false } = options || {};

    if (!raw) {
      if (response.status === 200) {
        return await response.json();
      } else {
        return "";
      }
    }

    let parsed = null;
    try {
      parsed = await response.json();
    } catch (e) {
      // ignore JSON parse errors in raw mode; caller can inspect status
    }

    return {
      ok: response.ok,
      status: response.status,
      data: parsed,
    };
  } catch (error) {
    // Handle any other errors that may occur during the API call

    console.error("API Error 2:", error.message);

    throw error; // Rethrow the error to allow the caller to handle it if needed
  } finally {
    //button.classList.remove('btn__dots--loading', 'clicked');
  }
};

//Convert epoch to human readable date time

export const uploadAssets = async (apiEndPoint, data = "", authToken = "") => {
  const apiUrl = laravelApiUrl + "/" + apiEndPoint;

  const response = await fetch(apiUrl, {
    method: "POST",

    body: data,

    headers: {
      Authorization: `Bearer ${authToken}`,
      "X-CITY": getCookie(cityCookieName) ?? 'pune',
      "x-app-key": appSecretKey,
    },
  });

  if (response.status === 200) {
    return await response.json();
  } else {
    return "";
  }
};

//Convert epoch to human readable date time

export const convertEpochToReadableTime = (epoch) => {
  const date = new Date(epoch * 1000); // Convert seconds to milliseconds

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };

  return date.toLocaleDateString("en-US", options);
};

//Format No

export const formatNumber = (formatNumber) => {
  try {
    const minprice =
      isNaN(formatNumber) || formatNumber === null || formatNumber === undefined
        ? 0
        : formatNumber;

    const minPriceValue = Number(minprice);

    // if (Array.isArray(jsonArray) && jsonArray.length > 0 && jsonArray[0].price !== undefined) {

    //   const minPriceValue = jsonArray[0].price;

    // console.log(jsonArray[0].price);

    //   if (!isNaN(minPriceValue)) {

    if (minPriceValue < 100000) {
      return minPriceValue; // No formatting needed for numbers less than 100,000
    } else if (minPriceValue < 10000000) {
      return (minPriceValue / 100000).toFixed(2) + "\u00A0L";
    } else {
      return (minPriceValue / 10000000).toFixed(2) + "\u00A0Cr";
    }

    //   }

    // }
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  return "0";
};

//Format No

export const formatNumberThousands = (formatNumber) => {
  try {
    const minprice = isNaN(formatNumber) ? 0 : formatNumber;

    const minPriceValue = JSON.parse(minprice);

    // if (Array.isArray(jsonArray) && jsonArray.length > 0 && jsonArray[0].price !== undefined) {

    //   const minPriceValue = jsonArray[0].price;

    // console.log(jsonArray[0].price);

    //   if (!isNaN(minPriceValue)) {

    if (minPriceValue < 100000) {
      return (minPriceValue / 1000).toFixed(2) + " K";

      //   return minPriceValue; // No formatting needed for numbers less than 100,000
    } else if (minPriceValue < 10000000) {
      return (minPriceValue / 100000).toFixed(2) + " L";
    } else {
      return (minPriceValue / 10000000).toFixed(2) + " Cr";
    }

    //   }

    // }
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

  return "0";
};

// date difference in months form current date

export const dateDiffInMonths = (date1, date2) => {
  const dt1 = new Date(date1);

  const dt2 = new Date(date2);

  let years = dt1.getFullYear() - dt2.getFullYear();

  let months = dt1.getMonth() - dt2.getMonth();

  let days = dt1.getDate() - dt2.getDate();

  // Adjust months if the days difference is negative

  if (days < 0) {
    months--;
  }

  let diff = years * 12 + months;

  return Math.abs(diff);
};

//Lazy Load Images

let lazyLoadInitiated = false;

export const lazyLoadImages = () => {
  if (lazyLoadInitiated) return;

  const lazyElements = document.querySelectorAll(".lazy[data-src]");

  const onScroll = () => {
    lazyElements.forEach((element) => {
      const dataSrc = element.getAttribute("data-src");

      if (dataSrc) {
        if (element.tagName === "IMG" || element.tagName === "IFRAME") {
          element.setAttribute("src", dataSrc);
        } else {
          element.style.backgroundImage = `url(${dataSrc})`;
        }

        element.removeAttribute("data-src");

        element.classList.remove("lazy");
      }
    });

    lazyLoadInitiated = true;

    window.removeEventListener("scroll", onScroll);
  };

  // Attach the scroll event listener

  window.addEventListener("scroll", onScroll);
};

export const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props}
    className={
      "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
    }
    aria-hidden="true"
    aria-disabled={currentSlide === 0}
    type="button"
  >
    Previous
  </button>
);

export const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
  <button
    {...props}
    className={
      "slick-next slick-arrow" +
      (currentSlide === slideCount - 1 ? " slick-disabled" : "")
    }
    aria-hidden="true"
    aria-disabled={currentSlide === slideCount - 1}
    type="button"
  >
    Next
  </button>
);

export const getSortBHKConf = (project) => {
  // replaced towers with configurations

  // if (project && Array.isArray(project.configurations)) {

  //     // Flatten and filter unique configurations

  //     const parseData = project.configurations;

  //     // const uniqueConfigs = parseData.flatMap(tower =>

  //     //         tower.configurations ? tower.configurations.map(config => config.name.replace(/(\d)\s*(?=\D)/g, '$1 ').replace(/\s*\.\s*/g, '.').toUpperCase()) : []

  //     //     )

  //     //     .filter((value, index, self) => self.indexOf(value) === index)

  //     //     .sort();

  //     const uniqueConfigs = parseData.map(config => config.name.replace(/(\d)\s*(?=\D)/g, '$1 ').replace(/\s*\.\s*/g, '.').toUpperCase()).filter((value, index, self) => self.indexOf(value) === index).sort();

  //         // console.log(uniqueConfigs);

  //     // Remove duplicate "BHK" entries and format configurations

  //     const formattedConfigs = uniqueConfigs.map(config => config.replace(/\s*(BHK)?$/, ''))

  //         .filter((value, index, self) => self.indexOf(value) === index);

  //     // Generate the output string with "and" separator for the last element

  //     const output = formattedConfigs.length > 1

  //         ? formattedConfigs.slice(0, -1).join(', ') + ', ' + formattedConfigs[formattedConfigs.length - 1] + ' BHK'

  //         : formattedConfigs.join(', ') + ' BHK';

  //     return output;

  // } else {

  //     return ''; // Return empty string or handle the non-array case as needed

  // }

  if (project && Array.isArray(project.towers)) {
    const bhksSet = new Set();

    project.towers.forEach((tower) => {
      tower.configurations.forEach((config) => {
        if (config.is_active === true && config.bedrooms != null) {
          // Use bedrooms field directly (most reliable)
          const bedrooms = Number(config.bedrooms);
          if (!isNaN(bedrooms) && bedrooms > 0) {
            bhksSet.add(bedrooms);
          }
        }
      });
    });

    // Convert to array and sort numerically
    const sortedBhks = Array.from(bhksSet).sort((a, b) => a - b);

    // Format as "2, 3, 4 BHK" - comma-separated numbers with BHK only at the end
    if (sortedBhks.length === 0) {
      return "";
    }

    // Join all BHK numbers with comma, then add " BHK" at the end
    return sortedBhks.join(", ") + " BHK";
  } else {
    return "";
  }
};

export const checkFileExtension = (url) => {
  if (url) {
    const allowedImageTypes = ["png", "jpg", "jpeg", "svg", "webp"];

    // Function to get the file extension from the URL

    const getFileExtension = (url) => {
      return url.split(".").pop().toLowerCase();
    };

    const extension = getFileExtension(url);

    return allowedImageTypes.includes(extension);
  }

  return false;
};

export const getMinMaxPrice = (project) => {
  if (project && Array.isArray(project.towers)) {
    const parseData = project.towers;

    let minPrice = Infinity;

    let maxPrice = -Infinity;

    parseData.forEach((tower) => {
      if (tower.configurations) {
        tower.configurations.forEach((config) => {
          const price = Number(config.final_price);

          if (price < minPrice) {
            minPrice = price;
          }

          if (price > maxPrice) {
            maxPrice = price;
          }
        });
      }
    });

    return { minPrice, maxPrice };
  } else {
    return { minPrice: null, maxPrice: null };
  }
};

export const getMinMaxCarpets = (project) => {
  if (project && Array.isArray(project.towers)) {
    const parseData = project.towers;

    let minCarpet = Infinity;

    let maxCarpet = -Infinity;

    parseData.forEach((tower) => {
      if (tower.configurations) {
        tower.configurations.forEach((config) => {
          const carpet = Number(config.carpet);

          if (carpet < minCarpet) {
            minCarpet = carpet;
          }

          if (carpet > maxCarpet) {
            maxCarpet = carpet;
          }
        });
      }
    });

    return { minCarpet, maxCarpet };
  } else {
    return { minCarpet: 0, maxCarpet: 0 };
  }
};

export const getMinMaxPricePerSqft = (project) => {
  if (project && Array.isArray(project.towers)) {
    const parseData = project.towers;

    // Group configurations by bedrooms (BHK) and store all price per sqft values for each BHK

    const pricePerSqftByBHK = {};

    parseData.forEach((tower) => {
      if (tower.configurations && Array.isArray(tower.configurations)) {
        tower.configurations.forEach((config) => {
          // Only process active configurations

          if (!config.is_active) return;

          // Get bedrooms (BHK) value

          const bedrooms = Number(config.bedrooms) || 0;

          if (bedrooms <= 0) return;

          // Prefer quoted_price (stored price per sqft) like project details page

          let pricePerSqft = null;

          // Check if quoted_price is available and valid

          if (
            config.quoted_price != null &&
            config.quoted_price !== "" &&
            config.quoted_price !== 0 &&
            config.quoted_price !== "0"
          ) {
            const quotedPrice = Number(config.quoted_price);

            if (!isNaN(quotedPrice) && quotedPrice > 0) {
              pricePerSqft = quotedPrice;
            }
          }

          // Fallback: Calculate from final_price / carpet if quoted_price not available

          if (pricePerSqft === null || pricePerSqft <= 0) {
            const finalPrice = Number(config.final_price);

            const carpet = Number(config.carpet);

            if (
              finalPrice > 0 &&
              carpet > 0 &&
              !isNaN(finalPrice) &&
              !isNaN(carpet)
            ) {
              pricePerSqft = finalPrice / carpet;
            }
          }

          // Store price per sqft for this BHK (collect all values for each BHK)

          if (pricePerSqft !== null && pricePerSqft > 0) {
            if (!pricePerSqftByBHK[bedrooms]) {
              pricePerSqftByBHK[bedrooms] = [];
            }

            pricePerSqftByBHK[bedrooms].push(pricePerSqft);
          }
        });
      }
    });

    // If no valid values found, return null

    const bhkValues = Object.keys(pricePerSqftByBHK);

    if (bhkValues.length === 0) {
      return { minPricePerSqft: null, maxPricePerSqft: null };
    }

    // Sort BHK values (bedrooms) numerically to get smallest and largest

    const sortedBHKs = bhkValues.map(Number).sort((a, b) => a - b);

    // Get min price per sqft from smallest BHK and max price per sqft from largest BHK

    const smallestBHK = sortedBHKs[0];

    const largestBHK = sortedBHKs[sortedBHKs.length - 1];

    // For smallest BHK, use minimum price per sqft

    // For largest BHK, use maximum price per sqft

    const smallestBHKPrices = pricePerSqftByBHK[smallestBHK];

    const largestBHKPrices = pricePerSqftByBHK[largestBHK];

    const minPricePerSqft = Math.min(...smallestBHKPrices);

    const maxPricePerSqft =
      sortedBHKs.length > 1
        ? Math.max(...largestBHKPrices)
        : Math.max(...smallestBHKPrices);

    return {
      minPricePerSqft: minPricePerSqft,

      maxPricePerSqft: maxPricePerSqft,
    };
  } else {
    return { minPricePerSqft: null, maxPricePerSqft: null };
  }
};

export const getComparisonProjectData = (project, aprData = {}) => {
  const getUniqueBhks = (project) => {
    const bhks = new Set();
    if (project?.towers && Array.isArray(project.towers)) {
      project.towers.forEach((tower) => {
        if (tower.configurations && Array.isArray(tower.configurations)) {
          tower.configurations.forEach((config) => {
            if (config.is_active && config.bedrooms != null) {
              const bedrooms = parseFloat(config.bedrooms);
              if (!isNaN(bedrooms) && bedrooms > 0) {
                bhks.add(bedrooms);
              }
            }
          });
        }
      });
    }
    return Array.from(bhks).sort((a, b) => a - b);
  };

  const getAprRange = (project, aprData) => {
    if (!project?.id) {
      return { minPricePerSqft: null, maxPricePerSqft: null };
    }

    console.log(
      `🔍 getAprRange called for project ${project.id} (${project.name || "Unknown"})`,
    );
    console.log(
      `   Available APR keys for this project:`,
      Object.keys(aprData || {}).filter((k) => k.startsWith(`${project.id}_`)),
    );

    const aprByBHK = {};
    const allBhks = getUniqueBhks(project);
    console.log(
      `   Project has ${allBhks.length} BHK configurations:`,
      allBhks,
    );

    allBhks.forEach((bedrooms) => {
      const exactKey = `${project.id}_${bedrooms}`;
      const aprValue = aprData[exactKey];

      console.log(
        `   Checking ${exactKey}: ${aprValue != null ? `Found ₹${aprValue}` : "NOT FOUND"}`,
      );

      if (aprValue != null && aprValue > 0 && !isNaN(aprValue)) {
        if (!aprByBHK[bedrooms]) {
          aprByBHK[bedrooms] = [];
        }
        aprByBHK[bedrooms].push(Number(aprValue));
      }
    });

    const availableBhks = Object.keys(aprByBHK)
      .map(Number)
      .sort((a, b) => a - b);
    if (availableBhks.length === 0) {
      console.warn(
        `❌ getAprRange: No APR data available for project ${project.id}. Expected BHKs: [${allBhks.join(", ")}]. Will fallback to calculated values.`,
      );
      return { minPricePerSqft: null, maxPricePerSqft: null };
    }

    const smallestBHK = availableBhks[0];
    const largestBHK = availableBhks[availableBhks.length - 1];
    const smallestBHKAprs = aprByBHK[smallestBHK];
    const largestBHKAprs = aprByBHK[largestBHK];

    const minPricePerSqft = Math.min(...smallestBHKAprs);
    const maxPricePerSqft =
      availableBhks.length > 1
        ? Math.max(...largestBHKAprs)
        : Math.max(...smallestBHKAprs);

    console.log(
      `✅ APR Range for Project ${project.id}: ₹${minPricePerSqft.toFixed(0)} (${smallestBHK} BHK) – ₹${maxPricePerSqft.toFixed(0)} (${largestBHK} BHK)`,
    );

    return { minPricePerSqft, maxPricePerSqft };
  };

  let pricePerSqftRange = getAprRange(project, aprData);

  if (
    pricePerSqftRange.minPricePerSqft === null ||
    pricePerSqftRange.maxPricePerSqft === null
  ) {
    console.warn(
      `⚠️ Project ${project.id}: No API APR data, falling back to getMinMaxPricePerSqft() calculation`,
    );
    pricePerSqftRange = getMinMaxPricePerSqft(project);
    if (pricePerSqftRange.minPricePerSqft !== null) {
      console.log(
        `   Fallback values: ₹${pricePerSqftRange.minPricePerSqft.toFixed(0)} – ₹${pricePerSqftRange.maxPricePerSqft.toFixed(0)}`,
      );
    }
  }

  let avgPricePerSqftDisplay = "N/A";
  if (
    pricePerSqftRange.minPricePerSqft !== null &&
    pricePerSqftRange.maxPricePerSqft !== null
  ) {
    const minFormatted = formatNumber(
      Math.round(pricePerSqftRange.minPricePerSqft),
    );
    const maxFormatted = formatNumber(
      Math.round(pricePerSqftRange.maxPricePerSqft),
    );
    const minRounded = Math.round(pricePerSqftRange.minPricePerSqft);
    const maxRounded = Math.round(pricePerSqftRange.maxPricePerSqft);

    if (minRounded === maxRounded) {
      console.log(
        `ℹ️ Project ${project.id} (${project.name}): Min = Max APR (${minRounded}), showing single value`,
      );
      avgPricePerSqftDisplay = `₹ ${minFormatted}`;
    } else {
      console.log(
        `✅ Project ${project.id} (${project.name}): APR Range ₹${minFormatted} – ₹${maxFormatted}`,
      );
      avgPricePerSqftDisplay = `₹ ${minFormatted} – ₹ ${maxFormatted}`;
    }
  } else if (
    project.quoted_per_sqft_price &&
    project.quoted_per_sqft_price !== "0" &&
    project.quoted_per_sqft_price !== 0
  ) {
    console.log(
      `ℹ️ Project ${project.id} (${project.name}): Using fallback quoted_per_sqft_price = ₹${project.quoted_per_sqft_price}`,
    );
    avgPricePerSqftDisplay = `₹ ${formatNumber(parseFloat(project.quoted_per_sqft_price).toFixed(0))}`;
  } else {
    console.warn(
      `⚠️ Project ${project.id} (${project.name}): No APR data and no quoted_per_sqft_price, showing N/A`,
    );
  }

  // Get configuration label
  const configurationDisplay = getSortBHKConf(project) || "N/A";

  // Get price range
  const priceData = getMinMaxPrice(project);
  const priceDisplay = `₹${formatNumber(priceData.minPrice)} - ₹${formatNumber(priceData.maxPrice)}`;

  // Get carpet area
  const carpetData = getMinMaxCarpets(project);
  const carpetDisplay = `${carpetData.minCarpet.toFixed(0)} - ${carpetData.maxCarpet.toFixed(0)} sq.ft.`;

  // Get possession date
  const dateValue =
    project.possession_date_readable ||
    project.possession ||
    project.possession_date;
  let possessionDisplay = "N/A";
  if (dateValue) {
    try {
      const formatted = convertShortDate(dateValue);
      possessionDisplay = formatted && formatted !== "N/A" ? formatted : "N/A";
    } catch (e) {
      possessionDisplay = "N/A";
    }
  }

  // Get years of experience
  let experienceDisplay = "N/A";
  if (project.developer) {
    const timestamp = project.developer.established_time_stamp;
    if (
      timestamp !== null &&
      timestamp !== undefined &&
      !(typeof timestamp === "number" && isNaN(timestamp))
    ) {
      try {
        const years = toCovertYear(timestamp);
        experienceDisplay = years === 0 ? "1" : years > 0 ? `${years}` : "N/A";
      } catch (e) {
        experienceDisplay = "N/A";
      }
    }
  }

  // Get density
  const density = project.project_size
    ? (project.total_units / project.project_size).toFixed(0)
    : "N/A";

  return {
    price: priceDisplay,
    avgPricePerSqft: avgPricePerSqftDisplay,
    configuration: configurationDisplay,
    location: project.address?.location || "N/A",
    projectSize: `${Number(project.project_size || 0).toFixed(2)} acres`,
    units: project.total_units || "N/A",
    density: density,
    carpetArea: carpetDisplay,
    amenities: `${project.amenities?.length || 0}`,
    possessionDate: possessionDisplay,
    developerName: project.developer?.name || "N/A",
    yearsOfExperience: experienceDisplay,
  };
};

export const toCovertYear = (established_time_stamp) => {
  // Handle null or undefined
  if (established_time_stamp === null || established_time_stamp === undefined) {
    return 0;
  }

  // Handle empty strings or whitespace-only strings
  if (typeof established_time_stamp === "string") {
    const trimmed = established_time_stamp.trim();
    if (
      trimmed === "" ||
      trimmed.toLowerCase() === "null" ||
      trimmed.toLowerCase() === "undefined"
    ) {
      return 0;
    }
    // First, try to parse as a date string (datetime format from database)
    // Handle MySQL datetime format: "2008-01-01 00:00:00" by normalizing to ISO format
    let dateString = trimmed;
    // Replace space with 'T' for ISO format if it matches YYYY-MM-DD HH:MM:SS pattern
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(trimmed)) {
      dateString = trimmed.replace(' ', 'T');
    }
    const parsedDate = new Date(dateString);
    if (!isNaN(parsedDate.getTime())) {
      // Successfully parsed as date, use the timestamp
      established_time_stamp = parsedDate.getTime();
    } else {
      // Not a valid date string, try parsing as pure numeric string
      // Only parse as number if the entire string is numeric (no date separators)
      if (/^\d+\.?\d*$/.test(trimmed)) {
        const parsed = parseFloat(trimmed);
        if (!isNaN(parsed)) {
          established_time_stamp = parsed;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
  }

  // Handle falsy numbers (0, NaN) - but 0 might be valid for some edge cases, so be careful
  if (
    typeof established_time_stamp === "number" &&
    isNaN(established_time_stamp)
  ) {
    return 0;
  }

  // If still falsy after string checks
  if (!established_time_stamp) {
    return 0;
  }

  try {
    // Handle numeric timestamps (Unix timestamp in seconds or milliseconds)
    let timestampValue = established_time_stamp;
    if (typeof established_time_stamp === "number") {
      // If timestamp is in seconds (less than year 2000 in milliseconds), convert to milliseconds
      if (established_time_stamp < 946684800000 && established_time_stamp > 0) {
        // Year 2000 in milliseconds - only convert if it's a reasonable seconds timestamp
        // Check if it's likely seconds (between 0 and year 2100 in seconds)
        if (established_time_stamp < 4102444800) {
          timestampValue = established_time_stamp * 1000;
        } else {
          timestampValue = established_time_stamp;
        }
      } else {
        timestampValue = established_time_stamp;
      }
    }

    const startDate = new Date(timestampValue);

    // Check if date is valid
    if (isNaN(startDate.getTime())) {
      return 0;
    }

    const today = new Date();
    const timeDiff = today.getTime() - startDate.getTime();

    // Check if timeDiff is valid (not negative or too large)
    if (timeDiff < 0 || timeDiff > 1000 * 3600 * 24 * 365.25 * 200) {
      // Max 200 years
      return 0;
    }

    const yearsDiff = timeDiff / (1000 * 3600 * 24 * 365.25);
    const totalYears = Math.floor(yearsDiff);

    return totalYears > 0 ? totalYears : 0;
  } catch (error) {
    return 0;
  }
};

export const convertShortDate = (date) => {
  // Handle null, undefined, or truly empty
  if (date === null || date === undefined) {
    return "N/A";
  }

  // Handle empty strings or whitespace-only strings
  if (typeof date === "string") {
    const trimmed = date.trim();
    if (
      trimmed === "" ||
      trimmed.toLowerCase() === "null" ||
      trimmed.toLowerCase() === "undefined"
    ) {
      return "N/A";
    }
    // Use trimmed value
    date = trimmed;
  }

  // Handle falsy numbers (0, NaN)
  if (typeof date === "number" && (date === 0 || isNaN(date))) {
    return "N/A";
  }

  // If date is falsy after string checks, return N/A
  if (!date) {
    return "N/A";
  }

  try {
    // Handle numeric timestamps (Unix timestamp in seconds or milliseconds)
    let dateValue = date;
    if (typeof date === "number") {
      // If timestamp is in seconds (less than year 2000 in milliseconds), convert to milliseconds
      if (date < 946684800000) {
        // Year 2000 in milliseconds
        dateValue = date * 1000;
      } else {
        dateValue = date;
      }
    }

    const longDate = new Date(dateValue);

    // Check if date is valid
    if (isNaN(longDate.getTime())) {
      return "N/A";
    }

    // Options for date formatting
    const options = { year: "numeric", month: "short" };

    // Convert long date to short format
    return longDate.toLocaleString("en-US", options);
  } catch (error) {
    return "N/A";
  }
};

export const convertDateTOddmmyyyy = (date) => {
  const longDate = new Date(date);

  // Options for date formatting

  const options = { year: "numeric", month: "short", day: "numeric" };

  // Convert long date to short format

  return longDate.toLocaleString("en-US", options);
};

export const numberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Field Validation functions

export const validateName = (name) => {
  if (!name) return "This field is required";

  return "";
};

export const validateEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailPattern.test(email)) return "Invalid email format";

  return "";
};

export const validatePhone = (phone) => {
  const phonePattern = /^\d{10}$/;

  if (!phonePattern.test(phone)) return "Phone number must be 10 digits";

  return "";
};

// export const createGa4Event = (action, category, name) => {

//     // Ensure 'name' is a string

//     if (typeof name === 'string') {

//         name = name.replace(/[^a-zA-Z0-9\/\- ]/g, ' ');

//     } else {

//         console.warn('The "name" parameter is not a string:', name);

//         name = String(name); // Convert to string to avoid further errors

//     }

//     // console.log('Google Analytics Event:', action, category, name);

//     TrackGoogleAnalyticsEvent(category, action, name);

// };

export const createGa4Event = (action, category, name, params = {}) => {
  // Normalize parameters

  try {
    // Ensure name is a string

    let eventName = "";

    if (typeof name === "string") {
      eventName = name.replace(/[^a-zA-Z0-9\/\- ]/g, " ").trim();
    } else if (name === undefined || name === null) {
      eventName = "";
    } else {
      eventName = String(name);
    }

    // Lowercase checked key for detection

    const lower = (action || "").toString().toLowerCase();

    const lowerName = eventName.toLowerCase();

    // BLOCK page view style events here (legacy/custom). This prevents duplicates.

    // Adjust matches as needed to include any other legacy labels you want to block.

    const pageViewLabels = [
      "page view",
      "page_view",
      "page-view",
      "pageview",
      "page view event",
      "page_view_event",
    ];

    if (pageViewLabels.includes(lower) || pageViewLabels.includes(lowerName)) {
      console.debug("[GA-SHIM] suppressed page_view style event:", {
        action,
        category,
        name,
      });

      return;
    }

    // If not blocked, send through normal tracker

    // convert label if needed (retain previous behaviour)

    let labelToSend = eventName;

    if (typeof labelToSend === "string") {
      labelToSend = labelToSend.replace(/[^a-zA-Z0-9\/\- ]/g, " ");
    } else {
      labelToSend = String(labelToSend);
    }

    TrackGoogleAnalyticsEvent(category, action, labelToSend, params);
  } catch (err) {
    console.warn("[GA] createGa4Event wrapper error", err);
  }
};

export const setUserSessionSourceCustom = (source, medium, campaign) => {
  if (source && medium && campaign) {
    setUserSessionSource(source, medium, campaign);
  }
};

export const isMobileDevice = () => {
  return window.innerWidth < 768; // Example threshold for mobile
};

export const generateSlug = (text) => {
  return text

    .toString() // Convert to string (in case it isn't)

    .normalize("NFD") // Normalize to decompose accented characters

    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics

    .toLowerCase() // Convert to lowercase

    .trim() // Trim whitespace

    .replace(/[^a-z0-9 -]/g, "") // Remove invalid characters

    .replace(/\s+/g, "-") // Replace spaces with hyphens

    .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
};

export function calculateMonth(status) {
  const timeValue = parseInt(status.match(/\d+/)[0], 10); // Extracts the numerical value

  const timeUnit = status.match(/[a-zA-Z]+/)[0]; // Extracts the unit of time (e.g., "months" or "years")

  if (timeUnit === "months") {
    return timeValue;
  } else if (timeUnit === "years") {
    return timeValue * 12;
  } else {
    throw new Error("Unsupported time unit");
  }
}

export const clearUrlParams = () => {
  const url = window.location.origin + window.location.pathname;

  window.history.replaceState(null, "", url);

  localStorage.removeItem("searchParams");

  localStorage.removeItem("selectedValues");
};

export const isScreenWidthGreaterThan992 = () => {
  return window.innerWidth > 992;
};

export const isScreenWidthLessThan992 = () => {
  return window.innerWidth <= 992;
};

export const loadGTMWithTimeout = (
  id,
  usePartytown = false,
  timeout = 5000,
) => {
  setTimeout(() => {
    const existingScript = document.getElementById("gtm-script");

    // Check if the GTM script is already added

    if (!existingScript) {
      setTimeout(() => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });

        const gtmScript = document.createElement("script");

        gtmScript.async = true;

        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;

        gtmScript.id = "gtm-script";

        // If usePartytown is true, offload GTM script to a web worker

        if (usePartytown) {
          gtmScript.type = "text/partytown";
        }

        const firstScript = document.getElementsByTagName("script")[0];

        firstScript.parentNode.insertBefore(gtmScript, firstScript);

        const gtagScript = document.createElement("script");

        gtagScript.async = true;

        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=AW-16665468291`;

        gtagScript.id = "gtag-script";

        document.head.appendChild(gtagScript);

        gtagScript.onload = function () {
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            (window.dataLayer = window.dataLayer || []).push(arguments);
          }

          window.gtag = gtag; // expose globally (important)

          gtag("js", new Date());

          gtag("config", "AW-16665468291");
        };

        // console.log('GTM script loaded after timeout');
      }, 5000); // Delay in milliseconds
    }
  }, timeout);
};

//   export const loadClarityWithTimeout = (timeout = 5000) => {

//     setTimeout(() => {

//       const existingScript = document.getElementById('clarity-script');

//       // Check if the Clarity script is already added

//       if (!existingScript) {

//         // Initialize Clarity function

//         window.clarity = window.clarity || function () {

//           (window.clarity.q = window.clarity.q || []).push(arguments);

//         };

//         // Dynamically create the Clarity script tag

//         const clarityScript = document.createElement('script');

//         clarityScript.async = true;

//         clarityScript.src = "https://www.clarity.ms/tag/qupz1n8ztq";

//         clarityScript.id = 'clarity-script'; // Set an ID for the script element

//         // Insert the Clarity script before the first script tag in the document

//         const firstScript = document.getElementsByTagName('script')[0];

//         firstScript.parentNode.insertBefore(clarityScript, firstScript);

//         console.log('Clarity script added successfully');

//       }

//     }, timeout);

//   };

export async function checkImageUrlValid(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image();

    img.src = imageUrl;

    // Image loaded successfully

    img.onload = () => resolve(true);

    // Error occurred (image not found, no permission, etc.)

    img.onerror = () => resolve(false);
  });
}

export const fetchLongLat = async (localityName) => {
  try {
    console.log(localityName);

    const response = await axios.get(
      "https://nominatim.openstreetmap.org/search",
      {
        params: {
          q: `${localityName} Maharashtra India`,

          format: "json",
        },

        timeout: 10000,
      },
    );

    const coordinates =
      response.data.length > 0
        ? [parseFloat(response.data[0].lat), parseFloat(response.data[0].lon)]
        : [18.49333, 73.85233]; // default coordinates

    return coordinates;
  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

export const applyGlobalHeaderMargin = (headerSelector, targetClass) => {
  const updateMargin = () => {
    const headerElement = document.querySelector(headerSelector);

    const targetElements = document.querySelectorAll(`.${targetClass}`);

    if (headerElement) {
      const headerHeight = headerElement.offsetHeight;

      targetElements.forEach((element) => {
        element.style.marginTop = `${headerHeight}px`;
      });
    } else {
      console.warn(`Header with selector "${headerSelector}" not found.`);
    }
  };

  // Initial margin application

  updateMargin();

  // Update margin on window resize

  window.addEventListener("resize", updateMargin);

  // Cleanup listener (return a function for `useEffect` cleanup)

  return () => {
    window.removeEventListener("resize", updateMargin);
  };
};

// Function to decode URL parameters and return an object or a string

export const decodeUrlParams = (input) => {
  try {
    // Decode the entire input

    const decodedInput = decodeURIComponent(input);

    // Check if the input looks like a URL with parameters

    if (input.includes("=") || input.includes("&")) {
      const urlParams = new URLSearchParams(decodedInput);

      const params = {};

      for (const [key, value] of urlParams.entries()) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }

      return params; // Return an object if it has parameters
    } else {
      // If it's not a URL, decode and clean spaces around commas

      return decodedInput

        .replace(/\+/g, " ") // Replace "+" with space

        .replace(/\s*,\s*/g, ","); // Remove spaces around commas
    }
  } catch (e) {
    console.error("Invalid input for decoding:", input);

    return null; // Return null if input is invalid
  }
};

//   fetch all the params from url in key value paire

//  if you want to skip any key pass it in array eg. allUrlParams(['key1', 'key2'])

export const allUrlParams = (keysToSkip = []) => {
  const urlParams = new URLSearchParams(
    decodeUrlParams(window.location.search),
  );

  const params = {};

  for (const [key, value] of urlParams.entries()) {
    if (!keysToSkip.includes(key)) {
      params[key] = value;
    }
  }

  return params;
};

export function toggleScroll(isDisabled) {
  if (isDisabled) {
    document.documentElement.style.overflow = "hidden";
  } else {
    document.documentElement.style.overflow = "auto";
  }
}

export function isElementInViewport(selector) {
  const element = document.querySelector(selector);

  if (!element) {
    console.error(`Element with selector "${selector}" not found.`);

    return false;
  }

  const rect = element.getBoundingClientRect();

  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Check if the top of the element is within the first 30% of the viewport

  const isInViewport = rect.top >= 0 && rect.top <= viewportHeight * 0.3;

  return isInViewport;
}

export function isChristmasTime() {
  const now = new Date();

  const kolkataTime = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
  );

  const month = kolkataTime.getMonth();

  const day = kolkataTime.getDate();

  return month === 11 && day >= 20 && day <= 29; // December is month 11 (0-indexed)
}

export function isRepublicTime() {
  const now = new Date();

  const kolkataTime = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
  );

  const month = kolkataTime.getMonth();

  const day = kolkataTime.getDate();

  return month === 0 && day >= 20 && day <= 29; // December is month 11 (0-indexed)
}

// cutome cookie

export const setCustomCookie = (name, value, days) => {
  let cookieString = `${name}=${value}; path=/`;

  if (days) {
    const expires = new Date(Date.now() + days * 86400000).toUTCString(); // Expiration time in UTC

    cookieString += `; expires=${expires}`;
  }

  document.cookie = cookieString;
};

export const getCustomCookie = (name) => {
  return Cookies.get(name);
};

export const getUTMParameter = (param) => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(param);
};

export const projectUrl = (project) => {
  return `${appUrl}/property/${generateSlug(project?.address?.city)}/${generateSlug(project?.address?.location)}/${project.slug}`;
};

export function convertToDays(dateString) {
  try {
    const inputDate = new Date(dateString);
    if (isNaN(inputDate)) return 0;

    const now = new Date();

    // Remove time part for accurate whole-day difference
    const input = inputDate.setHours(0, 0, 0, 0);
    const today = now.setHours(0, 0, 0, 0);

    const diffMs = today - input;

    // Convert ms → days
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
  } catch (error) {
    return 0;
  }
}





